import * as yup from 'yup'

import { MAXIMUM_IMAGE_SIZE } from '@/shared/utils/imageUploadUtility'
import { PHONE_NUMBER_REGEX } from '@/shared/config/constants'

export const emergencyContactSchema = yup
    .object({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        phoneNumber: yup
            .string()
            .matches(PHONE_NUMBER_REGEX, 'Phone number is not valid')
            .required('Phone Number is required'),
        address: yup.string().required(),
        city: yup.string().required(),
        state: yup.string().required(),
        country: yup.string().required(),
        children: yup.array().min(1, 'At least one child is required').required(),
        picture: yup
            .mixed()
            .required()
            .test('noImage', 'Image is required', (value: any) => {
                return value && value[0]?.size
            })
            .test(
                'fileSize',
                'The file is too large. Maximum allowed is 4MB',
                (value: any) => {
                    return value && value[0]?.size <= MAXIMUM_IMAGE_SIZE
                }
            )
    })
    .required()
